import PropTypes from "prop-types";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

import { API_URL } from "@config";
import useAuth from "@hooks/useAuth";

const POLL_MS = 20000;
const EMPTY = { total: 0, conversations: {} };

const ChatUnreadContext = createContext({ ...EMPTY, refresh: () => {} });

export const ChatUnreadProvider = ({ children }) => {
  const { user } = useAuth();
  const token = user?.sessionToken;
  const enabled = Boolean(token) && !user?.is_super_admin;
  const [unread, setUnread] = useState(EMPTY);

  const refresh = useCallback(() => {
    if (!enabled) return;
    axios
      .get(API_URL + "chat/unread", { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => setUnread(response.data.data))
      .catch(() => {});
  }, [enabled, token]);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const timer = setInterval(refresh, POLL_MS);
    return () => clearInterval(timer);
  }, [enabled, refresh]);

  const value = useMemo(() => ({ ...unread, refresh }), [unread, refresh]);

  return <ChatUnreadContext.Provider value={value}>{children}</ChatUnreadContext.Provider>;
};

ChatUnreadProvider.propTypes = {
  children: PropTypes.node,
};

export const useChatUnread = () => useContext(ChatUnreadContext);
